import './langueLoisir.scss'

function LangueLoisir(){


return(
            <div>
                <section id="languages"><h2 className="fs-40">Langues</h2></section>
                      <div className="lang"><img src="/img/icons/france.png"/><p>Langue maternelle</p></div>
                      <div className="lang"><img src="/img/icons/espana.png"/><p>Excellent</p></div>
                      <div className="lang"><img src="/img/icons/uk.png"/><p>Très bon</p></div>
                    <hr />
                    <section id="other">
                      <h2 className="fs-40">Autres</h2>
                      <article>
                        <p>Mes loisirs : </p>
                        <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" />  Nouvelles technologies</p>
                        <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" />  Saxophoniste</p>
                        <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" />  Sports en tout genre</p>
                        <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" />  Nature</p>
                        <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" />  Jeux de mots</p>
                        <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" />  Voyages</p>
                        <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" />  Cuisine</p>
                        <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" />  Grandes sensations</p>
                      </article>
                    </section>
            </div>
    )
}
export default LangueLoisir